import { Skeleton, Typography } from "@mui/material";

import { useAssetSalesPriceQuery } from "legacyNext/hooks";

type Props = {
    locale?: string;
    assetExternalId: string;
};

export const AssetSalesPrice = (props: Props) => {
    const { assetExternalId, locale = "da-DK" } = props;
    const { data, loading } = useAssetSalesPriceQuery(assetExternalId);

    if (loading) {
        return <Skeleton variant="text" sx={{ width: "100%" }} />;
    }

    if (!data) {
        return (
            <Typography variant="h5" fontWeight={600}>
                -
            </Typography>
        );
    }

    const { currency, salesPrice, salesDate } = data;

    const salesYear = salesDate ? new Date(salesDate).getFullYear() : null;

    const formatted = new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        maximumFractionDigits: 2,
    }).format(Number(salesPrice)) + (salesYear ? ` (${salesYear})` : "");

    return (
        <Typography variant="h5" fontWeight={600}>
            {formatted}
        </Typography>
    );
};
